var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoodle2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 985.008 1775",
    height: 1775,
    width: 985.008,
    xmlSpace: "preserve",
    id: "noodle-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfabout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,1331.248 H 738.756 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1775)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.5,1107.7725)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "none",
      stroke: "#f8952a",
      strokeWidth: 37,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 45.08,120.42 177.893,251.582 297.017,188.674 278.19,-146.911 -371.613,-729.872 -105.281,-870.52 86.96,-45.924 130.602,120.553 253.377,55.716 117.319,-61.955 -27.921,-238.862 61.52,-286.095 46.976,-24.808 55.519,31.012 109.921,2.283 57.46,-30.344 4.716,-136.826 85.202,-179.33"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoodle2);
export default __webpack_public_path__ + "static/media/Noodle-2.b22130de39cbbaf5112b7a991ef9fb7a.svg";
export { ForwardRef as ReactComponent };